// extracted by mini-css-extract-plugin
module.exports = {"checkListItem":"jm","checkListIconWrapper":"jn","checkListIcon":"jo","checkListText":"jp"};